// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__1G7aKpGl9koAi2dpFzSAz2"};